"use client";

import { ApiActual } from "@/api/article";
import { useStore } from "@/hooks/system/useStore";
import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useActualData = () => {
  const searchParams = useSearchParams();

  const { setSelectedFilters, selectedFilters } = useStore("actual");

  useEffect(() => {
    const year = searchParams.get("year");
    const page_number = searchParams.get("page_number") || 1;

    setSelectedFilters({
      pageNumber: +page_number,
      pageSize: 12,
      year: year ? +year : undefined,
    });
  }, [searchParams, setSelectedFilters]);

  const { data: actual, isLoading: actualLoading } = useLocalizedQuery({
    queryKey: ["actual", selectedFilters.pageNumber, selectedFilters.year],
    queryFn: async lang =>
      ApiActual.getActual(lang, {
        pageNumber: selectedFilters.pageNumber,
        pageSize: 12,
        year: selectedFilters.year,
      }),
  });

  const { data: actualYears, isLoading: actualYearsLoading } = useLocalizedQuery({
    queryKey: ["actualYears"],
    queryFn: async lang => ApiActual.getActualYears(lang),
  });

  return { actual, actualLoading, actualYears, actualYearsLoading };
};
